export default {
    MainLink: "OmniContact Cuscon",
    Logout: "Logout"
}